<template>
  <div class="promotion">
    <section-header class="mt-5 mb-5" title="優惠活動" subtitle="Promotions"/>
    <section class="row" v-if="promotions">
      <div class="col-12" v-for="(promotion, index) in promotions" :key="index">
        <router-link :to="`/w/promotion/detail/${promotion.actId}`" class="text-dark text-decoration-none">
          <div class="row gx-0 align-items-center border border-dark mb-4">
            <div class="col-sm-6">
              <div class="img" :style="util.getImageStyle(promotion.imgPath)"></div>
            </div>
            <div class="col-sm-6">
              <div class="m-3">
                <div class="title">{{ promotion.actName }}</div>
                <div class="desc mt-3" v-html="util.getHtml(promotion.actDesc)"></div>
              </div>
            </div>
          </div>
        </router-link>
      </div>
    </section>
  </div>
</template>

<script>
import constant from '@/constant.js'
import util from '@/util.js'
import promotionApi from '@/api/promotion.js'
import SectionHeader from '@/components/SectionHeader.vue'

export default {
  name: 'Promotion',
  components: {
    SectionHeader
  },
  data: function () {
    return {
      promotions: null
    }
  },
  computed: {
    util: function () {
      return util
    }
  },
  mounted: function () {
    this.apiGetPromotions()
  },
  methods: {
    apiGetPromotions: function () {
      var self = this
      promotionApi.getPromotions(function (err, rspData) {
        if (err) {
          if (err === constant.API_ERR_AUTH) {
            self.signOut()
          } else {
            alert(`${err}: ${rspData}`)
          }
          return
        }
        self.promotions = rspData
      })
    }
  }
}
</script>

<style scoped>
.img {
  width: 100%;
  padding-bottom: 60%;
}
.title {
  font-family: 'Noto Serif TC', serif;
  font-size: 1.8rem;
  font-weight: 700;
}
.desc {
  font-size: 1.3rem;
}

@media screen and (max-width: 767px) {
  .title {
    font-size: 1.6rem;
    font-weight: 500;
  }
}
</style>
